<template>
  <div class="row">
    <div class="col-md-12">
      <!-- <p>
        <a class="btn btn-success" href="javascript:void(0);" @click="collapse = !collapse">
          Download template surat <i class="fa fa-download"></i>
        </a>
      </p> -->
      <div v-if="!collapse">
        <div class="card card-body">
          <div class="row">
            <CustomMulti
              :label="$t('document_name')"
              size="6"
              :query="documentName"
              :list="documentNameList"
              :model="form.document_name"
              @data="setValue('document_name', $event)"
            />
            <div class="col-md-6">
              <label class="control-label">&nbsp;</label>
              <div>
                <a
                  class="btn btn-info"
                  v-if="form.document_name"
                  :href="form.document_name.link_file"
                  target="_blank"
                  ><i class="fa fa-download"></i
                ></a>
              </div>
            </div>
          </div>
          <div class="row" style="margin-top: 10px">
            <div class="col-md-12">
              <p>
                Silakan langsung edit pada
                <b style="font-weight: 900">Isi Surat</b>, abaikan bagian
                <b style="font-weight: 900">Pembuka Surat</b> karena data akan
                tergenerete secara otomatis oleh sistem.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12">
      <div class="card card-body printableArea">
        <h3>
          <b>{{ $t("drafting_list_signer") }}</b>
          <!-- <span class="pull-right">#5669626</span> -->
        </h3>
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb arr-right bg-white">
            <li class="breadcrumb-item"><a href="#">Home</a></li>
            <li class="breadcrumb-item active" aria-current="page">
              {{ $t("drafting_list_signer") }}
            </li>
          </ol>
        </nav>
        <hr />
        <div class="row">
          <p class="text-right h6 pl-3">Filtering Data</p>
        </div>

        <div class="row">
          <div class="col-md-6 col-sm-6">
            <div class="form-group">
              <CustomInput
                label="Nomor Surat"
                :model="customFilter.document_number"
                @data="setSearchValue('document_number', $event)"
                @clear="setSearchValue('document_number', $event)"
                label-block
                toggle-clear
              />
            </div>
            <div class="form-group">
              <CustomMulti
                label="Sifat Surat"
                :query="documentUrgency"
                :list="documentUrgencyList"
                :model="customFilter.document_urgency"
                @data="setSearchValue('document_urgency', $event)"
                @clear="setSearchValue('document_urgency', $event)"
                toggle-clear
                label-block
                close-on-select
              />
            </div>
          </div>
          <div class="col-md-6 col-sm-6">
            <div class="form-group">
              <CustomMulti
                label="Kecepatan Surat"
                :query="documentSpeed"
                :list="documentSpeedList"
                :model="customFilter.document_speed"
                @data="setSearchValue('document_speed', $event)"
                @clear="setSearchValue('document_speed', $event)"
                toggle-clear
                label-block
                close-on-select
              />
            </div>
            <div class="form-group">
              <CustomMulti
                label="Status Drafting"
                :query="documentApproval"
                :list="documentApprovalList"
                :model="customFilter.final_approved"
                @data="setSearchValue('final_approved', $event)"
                @clear="setSearchValue('final_approved', $event)"
                toggle-clear
                label-block
                close-on-select
              />
            </div>
          </div>
          <div class="col-md-6 col-sm-6">
            <div class="form-group">
              <CustomMulti
                label="Status Proses"
                :list="documentProcessList"
                :model="customFilter.status_process"
                @data="setSearchValue('status_process', $event)"
                @clear="setSearchValue('status_process', $event)"
                toggle-clear
                label-block
                close-on-select
              />
            </div>
          </div>
          <div class="col-md-12 col-sm-12">&nbsp;</div>
          <div class="col-md-6 col-sm-6">
            <div class="form-group">
              <button
                type="button"
                class="btn btn-outline-secondary"
                @click="loadItems()"
              >
                Cari
              </button>
            </div>
          </div>

          <!-- <div class="col-md-6 col-sm-6">
            <form method="post" @submit.prevent="filterData">
              <div class="form-group">
                  <label for="tanggal">Tanggal</label>
                  <div class="row">
                      <div class="col-6">
                          <div class="form-group">
                              <input
                                type="date"
                                class="form-control"
                                data-date=""
                                data-date-format="YYYY-MM-DD"
                                v-model="start_date"
                              />
                          </div>
                      </div>
                      <div class="col-6">
                          <div class="form-group">
                              <input
                                type="date"
                                class="form-control"
                                data-date=""
                                data-date-format="YYYY-MM-DD"
                                v-model="end_date"
                              />
                          </div>
                      </div>
                  </div>
              </div>
            </form>
          </div> -->
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="row m-b-10">
              <div class="col-lg-12">
                <a
                  class="btn btn-success"
                  href="javascript:void(0);"
                  @click="collapse = !collapse"
                >
                  Download template surat <i class="fa fa-download"></i>
                </a>
              </div>
            </div>
            <vue-good-table
              mode="remote"
              :pagination-options="{
                enabled: true,
                setCurrentPage: curPage,
                jumpFirstOrLast : true,
              }"
              @on-page-change="onPageChange"
              @on-sort-change="onSortChange"
              @on-column-filter="onColumnFilter"
              @on-per-page-change="onPerPageChange"
              :totalRows="total"
              :columns="columns"
              :rows="rows"
              :isLoading.sync="isLoading"
              fixed-header
            >
              <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field === 'id'">
                  <button
                    type="button"
                    @click="doDetail({ id: props.row.id })"
                    class="btn btn-success btn-sm"
                  >
                    <i class="mdi mdi-magnify"></i>
                  </button>
                  <button
                    v-if="props.row.can_approve == true"
                    type="button"
                    @click="doApprove({ id: props.row.id })"
                    class="btn btn-warning btn-sm"
                  >
                    <i class="mdi mdi-check-circle-outline"></i>
                  </button>
                </span>
                <span v-else>
                  {{ props.formattedRow[props.column.field] }}
                </span>
              </template>
            </vue-good-table>
            <!-- <Datatables table-name="drafting_file" @doDetail="doDetail" @doEdit="doEdit" @doDelete="doDelete" :action="true" :columnFiltering="true" action-data="row_number" :url="'drafting-file'" :dtfields="headers">
              <template slot-scope="props">
              <div class="btn-group btn-sm" role="group" aria-label="Basic example">
                <button type="button" data-action="doDetail" class="btn btn-success btn-sm"><i class="mdi mdi-magnify"></i></button>
                <button type="button" data-action="doEdit" class="btn btn-warning btn-sm"><i class="mdi mdi-grease-pencil"></i></button>
                <button v-if="props.ctx.data.deleteable" type="button" data-action="doDelete" class="btn btn-danger btn-sm"><i class="fa fa-times"></i></button>
              </div>
              </template>
            </Datatables> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    // let _this = this
    return {
      curPage: 1,
      documentSpeedList: [],
      documentUrgencyList: [],
      documentApprovalList: [],
      // documentApprovalList: [
      //   { value: 1, text: "Approved" },
      //   { value: 2, text: "Pending" },
      //   { value: 3, text: "Decline" },
      //   { value: 4, text: "Revision" },
      //   { value: 5, text: "Retract/Cancelled" },
      //   { value: 6, text: "Draft" },
      // ],
      documentProcessList: [
        { value: 0, text: "Perlu Diproses" },
        { value: 1, text: "Sudah Diproses" },
      ],
      documentNameList: [],
      collapse: true,
      form: {
        document_name: null,
      },
      columns: [
        { label: "Action", field: "id", sortable: false },
        { label: "Nomor Surat", field: "document_number", sortable: false },
        { label: "Perihal", field: "subject" },
        { label: "Tanggal", field: "document_date" },
        { label: "Penanda Tangan", field: "signers_text", sortable: false },
        { label: "Drafter", field: "creator.name", sortable: false },
        { label: "Status", field: "final_approvement.name", sortable: false },
      ],
      rows: [],
      isLoading: false,
      total: 0,
      serverParams: {
        columnFilters: {},
        sort: [],
        page: 1,
        perPage: 10,
      },
      customFilter: {
        document_number: null,
        final_approved: null,
        document_urgency: null,
        document_speed: null,
        status_process: null,
      },
      // headers:{
      //   agenda_number:{
      //     label:'Nomor Agenda',
      //     data:'agenda_number',
      //   },
      //   subject:{
      //     label:'Perihal',
      //     data:'subject',
      //   },
      //   document_date:{
      //     label:'Tanggal',
      //     data:'document_date',
      //     render:function(data){
      //       return new Date(data).toDateString();
      //     }
      //   },
      //   // document_number:{
      //   //   label:'Nomor Surat',
      //   //   data:'document_number',
      //   // },
      //   sender_id:{
      //     label:'Penanda Tangan',
      //     data:'sender.name',
      //   },
      //   created_by:{
      //     label:'Drafter',
      //     data:'creator.name',
      //   },
      //   final_approved:{
      //     label:'Status',
      //     data:'final_approvement.name',
      //     render:function(data){
      //       return _this.$t(data)
      //     }
      //   },
      // }
    };
  },
  computed: {},
  async created() {
    let curPage = localStorage.getItem('drafting_file_signer.curPage');
    curPage = curPage ? curPage : 1;
    this.curPage = curPage * 1;
  },
  async mounted() {
    const state = {
      loaded: false,
      isAdd: false,
      isApprove: false,
      isDetail: false,
    };
    this.$store.commit("drafting_file_signer/STATE", state);
    await this.loadItems();
  },
  methods: {
    setValue(model, data) {
      this.form[model] = data;
    },
    setSearchValue(model, data) {
      this.customFilter[model] = data;
    },
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },

    onPageChange(params) {
      this.updateParams({ page: params.currentPage });
      this.loadItems();
      localStorage.setItem('drafting_file_signer.curPage', params.currentPage);
    },

    onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage });
      this.loadItems();
    },

    onSortChange(params) {
      this.updateParams({
        sort: params,
      });
      this.loadItems();
    },

    onColumnFilter(params) {
      this.updateParams(params);
      this.loadItems();
    },
    async loadItems() {
      this.isLoading = true;

      let { perPage, page, sort } = this.serverParams;

      let {
        document_number,
        final_approved,
        document_urgency,
        document_speed,
        status_process,
      } = this.customFilter;

      let start = (page - 1) * perPage;
      let url =
        "drafting-file-signer?perPage=" +
        perPage +
        "&page=" +
        start +
        "&jenis=surat";

      if (document_number) {
        url += "&number=" + document_number;
      }
      if (final_approved) {
        url += "&approved=" + final_approved.value;
      }
      if (document_urgency) {
        url += "&urgency=" + document_urgency.value;
      }
      if (document_speed) {
        url += "&speed=" + document_speed.value;
      }
      if (status_process) {
        url += "&status_process=" + status_process.value;
      }

      if (sort.length) {
        sort.forEach((item, index) => {
          url +=
            `&sort[${index}][field]=${item.field}` +
            `&sort[${index}][type]=${item.type}`;
        });
      }

      let resp = await axios.get(url);

      this.rows = resp.data.data;
      this.total = resp.data.recordsTotal;

      this.isLoading = false;
    },
    documentUrgency(query) {
      axios.get(`document_urgencies/list?s=${query}`).then((res) => {
        this.documentUrgencyList = res.data.items;
      });
    },
    documentSpeed(query) {
      axios.get(`document_speeds/list?s=${query}`).then((res) => {
        this.documentSpeedList = res.data.items;
      });
    },
    documentApproval(query) {
      axios.get(`document_approval/list?s=${query}`).then((res) => {
        this.documentApprovalList = res.data.items;
      });
    },
    documentName(query) {
      axios.get(`clasification/list-active?s=${query}`).then((res) => {
        this.documentNameList = res.data.items;
      });
    },

    doDetail(val) {
      this.$store.dispatch("drafting_file_signer/onDetail", val);
      // const idsurat = val.id;
      // let route = this.$router.resolve({path: '/drafting-file/detail'});
      // let route1 = `${route.href}/${idsurat}`;
      // window.open(route1,'_blank');
    },
    doApprove(val) {
      this.$store.dispatch("drafting_file_signer/onApprove", val);
    },
  },
};
</script>
